import React, { useState } from 'react';
import RfiForm from '../components/form/RfiForm';
import LoadingSpinner from '../components/loadingSpinner';
import { RfiCompletedPage } from './rfiCompletedPage';

export default function CreateRFI() {
	const [isSubmitted, setIsSubmitted] = useState(false);
	const [rfiForm, setRfiForm] = useState(null);
	const [attachments, setAttachments] = useState([]);

	const openSubmissionCompletedScreen = (rfi, files) => {
		setIsSubmitted(true);
		setRfiForm(rfi);
		setAttachments(files);
	}

	const openNewRfi = () => {
		setIsSubmitted(false);
		setRfiForm(null);
		setAttachments([]);
	}

	return (
		<div>
			{isSubmitted
				? rfiForm
					? <RfiCompletedPage rfi={rfiForm} attachments={attachments} openNewForm={openNewRfi} />
					: <LoadingSpinner />
				: <RfiForm isInternal={false} onSubmitted={openSubmissionCompletedScreen} />
			}
		</div>
	);
}